export const containsChild = (node: Node, otherNode: Node | null): boolean => {
    return node !== otherNode && node.contains(otherNode);
};
